/* istanbul ignore file */

import { styled } from '@mui/material/styles';

import { rem, Theme } from '../../theme';

export const StyledTermsWrapper = styled('small')`
    ${({ theme }: { theme: Theme }) => theme.typography.bodyXXSmall};
    ${({ theme }: { theme: Theme }) => `
        display: block;
        padding-top: ${theme.tggSpacing(rem(2), 12)};
        padding-bottom: ${theme.tggSpacing(rem(3.6), 8)};
        padding-right: ${theme.tggSpacing(rem(3), 6)};
        padding-left: ${theme.tggSpacing(rem(3), 6)};
        background-color: ${theme.palette.common.white};
        span{
        color: ${theme.getRebrandingColor('', theme.palette.tgg.text.label)};
        }
        ${theme.breakpoints.up('desktop')} {
        padding-bottom: ${theme.tggSpacing(rem(3.6), 10)};
            padding-right: ${theme.tggSpacing(rem(30), 12)};
            padding-left: ${theme.tggSpacing(rem(30), 12)};
            text-align:${theme.tggSpacing('center', 'unset')};
        }
        ${theme.breakpoints.up('largeDesktop')} {
            padding-right: ${theme.tggSpacing(rem(30), 20)};
            padding-left: ${theme.tggSpacing(rem(30), 20)};
        }
    `}
`;

export const StyledAsterisk = styled('span')`
    color: ${({ theme }: { theme: Theme }) => theme.palette.primary.main};
`;
